<ng-container>
	<base-display [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()"></base-display>
</ng-container>